export default __webpack_public_path__ + "static/media/icon-magnifier-white.863a34b5.svg";